import React from 'react';
import styled from 'styled-components';
import { IconCircledCheck, IconClose, IconInfo, IconWarning } from '../../components/ui/Icons';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import { openNotification } from './notificationService';

const StyledIconWrapper = styled.span`
  /* without this the line box of the span lifts the icon off the first line of text */
  display: flex;

  svg * {
    fill: transparent;
    stroke: ${(props) => props.$color};
  }

  svg path.dot {
    fill: ${(props) => props.$color};
    stroke: transparent;
  }
`;

const StyledCloseIcon = styled.span`
  display: flex;

  svg path {
    stroke: ${(props) => props.$color};
  }
`;

/*
The notification itself is white, the type only shows in the icon and in the border. The border
lives in global.css because Ant sets the type as a class on the notice element.
*/
const TYPES = {
  success: { accentColor: 'var(--primary-oqio-green)', Icon: IconCircledCheck },
  error: { accentColor: 'var(--primary-oqio-red)', Icon: IconWarning },
  info: { accentColor: 'var(--primary-oqio-blue)', Icon: IconInfo }
};

const getKey = (message) => {
  switch (message) {
    case NOTIFICATION_MESSAGES.password_forgot_success:
      return 'notification-forgot-password';
    default:
      return undefined;
  }
};

const renderNotification = ({ type, message, duration, ...props }) => {
  // an unknown type would reach Ant as an unknown method and would miss its border
  const notificationType = TYPES[type] ? type : 'info';
  const { accentColor, Icon } = TYPES[notificationType];

  return openNotification(notificationType, {
    key: getKey(message),
    title: message,
    duration: duration === undefined ? 5 : duration,
    icon: (
      <StyledIconWrapper $color={accentColor}>
        <Icon />
      </StyledIconWrapper>
    ),
    closeIcon: (
      <StyledCloseIcon $color="var(--greyscale-blackish)">
        <IconClose />
      </StyledCloseIcon>
    ),
    ...props
  });
};
export default renderNotification;
